import React, { Component } from 'react';
import { Button } from 'react-md';
import PropTypes from "prop-types";

import logo from 'static/images/logo.png';

class ErrorBoundary extends Component {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch() {
    return; // Would like to wire up some client-side logging at some point
  }

  render() {
    if (this.state.hasError || this.props.force) {
      let redirectPath = window.location.href.includes('webui')
        ? '../webui/'
        : '../';
      return (
        <div className="error-page">
          <div className="content">
            <img src={logo} />
            <div className="message">
              <h6>Oh no, an error has occurred. Please try again, or contact <a href="https://www2.muellerreports.com/contact-us/" target="_blank">Technical Support</a> if the issue persists.</h6>
              <Button primary raised onClick={() => window.location.replace(redirectPath)}>Home</Button>
            </div>
          </div>
        </div>);
    } else {
      return this.props.children;
    }
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.object,
  force: PropTypes.bool,
};

export default ErrorBoundary;